import ReactTable from "../../components/react-table/solicitude-maintenance";

function MaintenanceSolicitudCompra() {
  return (
    <div>
      <ReactTable contextmenu="mantiene" />
    </div>
  );
}

export default MaintenanceSolicitudCompra;
